<div class="row m-0 p-0">
  <div class="col-12 d-flex justify-content-between">
    <h6 class="fw-bold fs-27">
      Navigation
      <div class="border-green-bottom mt-1"></div>
    </h6>
    <div>
      <button class="btn btn-primary border-radius-10" matRipple (click)="onClickAddMenu()">Add Menu</button>
    </div>
  </div>
  <div class="border-bottom mb-2 mt-2"></div>

  <div class="col-12">
    <ng-container *ngIf="masterMenuList.length > 0">
      <ng-container *ngFor="let item of masterMenuList">
        <ng-container *ngTemplateOutlet="NavigationItems; context: { item: item }"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #NavigationItems let-NavItem="item">
  <div class="d-flex align-items-start mt-2">
    <div
      *ngIf="NavItem?.ChildList?.length > 0"
      [innerHtml]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'"
      class="me-2 mt-2 cursor-pointer"
      (click)="onClickMenuItem(NavItem)"
      [@indicatorRotate]="NavItem?.IsExpanded ? 'expanded' : 'collapsed'"
      (keydown.enter)="onClickMenuItem(NavItem)"
      (keydown.space)="onClickMenuItem(NavItem)"
      tabindex="0"
      role="button"></div>

    <div *ngIf="NavItem?.ChildList?.length === 0" class="me-2 mt-2" style="width: 24px"></div>

    <div class="w-100 d-flex justify-content-between align-items-center pe-3 rowheight --border-radius-5 --border-primary navigation-item-card">
      <div class="d-flex align-items-center px-3">
        <small>{{ NavItem?.MenuID }}</small
        >&nbsp;&nbsp;&nbsp;
        <span>{{ NavItem?.MenuName }}</span>
        <span class="ms-2 --text-primary">{{ NavItem?.RouterPath }}</span>
      </div>
      <div class="d-flex">
        <div
          [innerHtml]="SVG_ICONS.EDIT_PENCIL() | sanitizer : 'html'"
          class="mt-2 ms-3 mb-2"
          (click)="onClickEditItem(NavItem)"
          (keydown.enter)="onClickEditItem(NavItem)"
          (keydown.space)="onClickEditItem(NavItem)"
          tabindex="0"
          role="button"></div>
        <!-- <div [innerHtml]="SVG_ICONS.DESC_ICON() | sanitizer : 'html'" class="mt-2 ms-3" (click)="OnClickAddNavigation(NavItem)" (keydown.enter)="OnClickAddNavigation(NavItem)" (keydown.space)="OnClickAddNavigation(NavItem)" tabindex="0" role="button"> </div> -->
      </div>
    </div>
  </div>

  <div *ngIf="NavItem?.ChildList?.length > 0 && NavItem?.IsExpanded">
    <div *ngFor="let child of NavItem?.ChildList" class="ps-4">
      <ng-container *ngTemplateOutlet="NavigationItems; context: { item: child }"></ng-container>
    </div>
  </div>
</ng-template>
